import { Customer } from '@/models/customer';
import { Station } from '@/models/station';

export function getCustomerName(station: Station): string {
  const customer = station.customer;
  if (!customer || typeof customer === 'string') return '';
  return (customer as Customer).name || '';
}
